import { Cookies } from 'react-cookie';

import { SiteFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const createSite = async (object: SiteFormValues) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const requestData = {
    ...object,
    company: object.company ?? null,
    technicians: object.technicians ?? [],
  };

  const { data } = await axiosInterceptor.post('/objects/', requestData, {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  });

  return data as any;
};
